export default __webpack_public_path__ + "static/media/project8.de744ec2.png";